import type React from 'react'
import { PlanRadioCard } from '../../../components/FormElements/SubscriptionRadioCard'
import { SUBSCRIPTION_PLANS } from '../../../lib/utils/subscriptionPlans'
import { capitalize } from 'lodash'

export const PaymentStep: React.FC = () => {
  return (
    <div className="flex flex-col gap-3">
      <div className="flex flex-col gap-2">
        {SUBSCRIPTION_PLANS.map((plan) => {
          return (
            <PlanRadioCard
              name={'plan'}
              value={plan.name}
              title={`${capitalize(plan.name)} Plan`}
              price={plan.price}
              description={plan.description}
            />
          )
        })}
      </div>
    </div>
  )
}
